// A RUM `view` whose URL points at an `*/initial_page_data` endpoint is not a
// real page. Those paths are the app's JSON data-fetch convention (container
// components `fetch(`${location.pathname}/initial_page_data`)`); they only get
// recorded as views when the JSON URL is loaded as a document directly (bots,
// link prefetch, an opened tab), and they pollute the per-view Core Web Vitals
// and error-rate metrics. We drop those view events at ingestion. (ENG-7)
export function isDataEndpointView(event) {
  return (
    event?.type === "view" &&
    /\/initial_page_data(?:[/?#]|$)/.test(event?.view?.url || "")
  );
}
